const fn = {
  init: () => {

    // close buttons
    const tingleClose = document.querySelector('.tingle-modal__close');
    const dialogClose = document.querySelector('.dialog-close');

    // modal containers
    const tingleContainer = document.querySelector('.tingle-modal.modal.modal--content.tingle-modal--visible');
    const dialogContainer = document.querySelector('#dialog-overlay');

    // tingle modal contents
    const tingleContent = document.querySelector('.tingle-modal-box');
    const tingleContentImage = document.querySelector('.tingle-modal-box img');

    // mobile device size
    const mobileScreenSize = window.matchMedia('screen and (max-width: 768px)')

    // webkit flag for apple
    let webKit = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && /iPad|iPhone|iPod/.test(navigator.platform);

    if (mobileScreenSize.matches || mobileScreenSize.webkitMatchesSelector || mobileScreenSize.mozMatchesSelector || mobileScreenSize.msMatchesSelector) {

        if (tingleContainer && dialogContainer) {

            tingleContainer.append(dialogContainer)

            tingleContainer.style.overflow = "scroll"
            tingleContainer.style.gap = "20px"
            tingleContainer.style.padding = "10px 0"

            dialogContainer.style.translate = "0";
            dialogContainer.style.position = "unset"

        }
    } else {
        if(tingleClose) {
            tingleClose.addEventListener('click', () => {
                if (dialogContainer) {
                    dialogContainer.style.maxWidth = "100%";
                    dialogContainer.style.translate = "0";
                    dialogContainer.style.transition = "all .5s ease-in-out"
                }
            })
        }

        if (dialogClose) {
            dialogClose.addEventListener('click', () => {
                tingleContainer.style.maxWidth = "100%";
                tingleContainer.style.transition = "all .5s ease-in-out"
            })
        }

        window.addEventListener("load", () => {
            // if both modals are active, set each to 50% width
            if (dialogContainer && tingleContainer && !webKit ) {

                tingleContainer.style.maxWidth = "50%";
                dialogContainer.style.maxWidth = "50%";

                dialogContainer.style.translate = "100%"
            }

            if (dialogContainer == null) {
                if (tingleContainer) {
                    tingleContainer.style.width = "100%";
                }
            }

            if (tingleContainer == null) {
                if (dialogContainer) {
                    dialogContainer.style.width = "100%";
                    dialogContainer.style.translate = "0";
                }
            }
        })
    }

    if(webKit) {
        if (tingleContainer && dialogContainer) {

            tingleContainer.append(dialogContainer)

            tingleContainer.style.overflow = "scroll"
            tingleContainer.style.gap = "20px"
            tingleContainer.style.padding = "10px 0"

            dialogContainer.style.translate = "0";
            dialogContainer.style.position = "unset"

            tingleContent.style.padding = "1px !important"
        }

        if (tingleClose) {
            tingleClose.addEventListener('click', () => {
                let documentBody = document.querySelector('body');
                documentBody.append(dialogContainer)
                dialogContainer.style.position = "fixed"
            })
        }
    }
  },
}

export default {
  can: () => true,
  run: fn.init,
}
